import { composeU } from '@bem-react/core';

import BaseLevel from 'client/common/components/level';

import { withLevelTypeAboutCompany } from './_type/level_type_aboutCompany';
import { withLevelTypeAgency } from './_type/level_type_agency';
import { withLevelTypeCarousel } from './_type/level_type_carousel';
import { withLevelTypeCta } from './_type/level_type_cta';
import { withLevelTypeDownload } from './_type/level_type_download';
import { withLevelTypeFilters } from './_type/level_type_filters';
import { withLevelTypeMarkedText } from './_type/level_type_markedText';
import { withLevelTypeMedia } from './_type/level_type_media';
import { withLevelTypeQuote } from './_type/level_type_quote';
import { withLevelTypeResults } from './_type/level_type_results';
import { withLevelTypeThumb } from './_type/level_type_thumb';
import { withLevelTypeVideo } from './_type/level_type_video';

import './index.css';

const Level = composeU(
    withLevelTypeAboutCompany,
    withLevelTypeDownload,
    withLevelTypeAgency,
    withLevelTypeQuote,
    withLevelTypeFilters,
    withLevelTypeMedia,
    withLevelTypeResults,
    withLevelTypeCta,
    withLevelTypeCarousel,
    withLevelTypeThumb,
    withLevelTypeMarkedText,
    withLevelTypeVideo
)(BaseLevel);

export default Level;
